export default {

    FB_ADMINS: 'admins',

    FB_MEMBERS: 'members',

    FB_LOANS: 'loans',
    FB_SAVINGS: 'savings',
    FB_REGISTRATION_FEES: 'registration_fees',
    FB_CAPITAL_CONTRIBUTIONS: 'capital_contributions',

    FB_MEMBER_CONTRIBUTIONS: 'member_contributions',
    FB_MEMBER_ALLOCATIONS: 'member_allocations',

    FB_COUNTERS: "counters",

    FB_MESSAGES: 'messages',
    FB_TRANSACTIONS: 'transactions',

    FB_MPESA_STK_TRANSACTIONS: 'mpesa_stk_transactions',

    FB_NOTIFICATIONS: 'notifications',
    FB_ACTIVITY_LOGS: 'acivity_logs',

    FB_SETTINGS: 'settings',

    FB_ALLOCATIONS: 'allocations',

    DEFAULT_OWNER: 'hayaan',

    pageSize: 10,
    evcUssd: 789,
}
